/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { SaleDateChangeCommand } from "@/models/api/commands/order/SaleDateChangeCommand";
import { IssueDateChangeCommand } from "@/models/api/commands/order/IssueDateChangeCommand";
import { ClearContractorCommand } from "@/models/api/commands/order/ClearContractorCommand";
import { CONTRACTOR_TYPES } from "@/static/contractorTypes";
import {
  PaymentDateChangeCommand,
  PaymentDateChangeCommandParams,
} from "@/models/api/commands/order/PaymentDateChangeCommand";
import { CommentChangeCommand } from "@/models/api/commands/order/CommentChangeCommand";
import { BankAccountChangeCommand } from "@/models/api/commands/order/BankAccountChangeCommand";
import { CurrencyChangeCommand } from "@/models/api/commands/order/CurrencyChangeCommand";
import { FormOfPaymentChangeCommand } from "@/models/api/commands/order/FormOfPaymentChangeCommand";
import { RecalculateAllOrderItemsCommand } from "@/models/api/commands/order/RecalculateAllOrderItemsCommand";
import { OrderItemMoveUpCommand } from "@/models/api/commands/order/OrderItemMoveUpCommand";
import { OrderItemMoveDownCommand } from "@/models/api/commands/order/OrderItemMoveDownCommand";
import { UpdateSummaryPrintCommand } from "@/models/api/commands/order/UpdateSummaryPrintCommand";
import {
  ChargeFromContractor,
  SetChargeFromCustomContractorCommand,
} from "@/models/api/commands/order/ContractorSetChargeFromPayerCommand";
import { ContractorSetHiddenCommand } from "@/models/api/commands/order/ContractorSetHiddenCommand";
import { DeleteOrderItemCommand } from "@/models/api/commands/order/DeleteOrderItemCommand";
import { ImportBookingItemsCommand } from "@/models/api/commands/order/ImportBookingItemsCommand";
import { SaveTradeTermToOtherOrderCommand } from "@/models/api/commands/order/SaveTradeTermToOtherOrderCommand";
import { ResetOrderItemCommand } from "@/models/api/commands/order/ResetOrderItemCommand";
import { ResetRelatedOrderItemCommand } from "@/models/api/commands/order/ResetRelatedOrderItemCommand";

import { ReturnBookingItemCommand } from "@/models/api/commands/order/ReturnBookingItemCommand";
import { ReturnRelatedBookingItemCommand } from "@/models/api/commands/order/ReturnRelatedBookingItemCommand";
import { RefundBookingItemCommand } from "@/models/api/commands/order/RefundBookingItemCommand";
import { RemoveFeesCommand } from "@/models/api/commands/order/RemoveFeesCommand";
import { DuplicateOrderItemCommand } from "@/models/api/commands/order/DuplicateOrderItemCommand";
import {
  OrderItemMoveToPositionCommand,
  OrderItemMoveToPositionCommandParams,
} from "@/models/api/commands/order/OrderItemMoveToPositionCommand";
import { OwnerChangeCommand } from "@/models/api/commands/order/OwnerChangeCommand";
import { EditOwnerCommand, EditOwnerParams } from "@/models/api/commands/order/EditOwnerCommand";
import { AddOwnerCommand, AddOwnerParams } from "@/models/api/commands/order/AddOwnerCommand";
import { DeleteOwnerCommand } from "@/models/api/commands/order/DeleteOwnerCommand";
import { ComplementAmountToAllCommand } from "@/models/api/commands/order/ComplementAmountToAllCommand";
import { ComplementAmountCommand } from "@/models/api/commands/order/ComplementAmountCommand";
import { AddTradeTermCommand } from "@/models/api/commands/order/AddTradeTermCommand";
import { AddTradeTermToAllCommand } from "@/models/api/commands/order/AddTradeTermToAllCommand";
import { OrderGetServiceTypeAttributeItem } from "@/models/api/orders/temporary/OrderGetServiceTypeAttributes";
import {
  CopyAttributeToOtherOrderItemsCommand,
  CopyAttributeToOtherOrderItemsCommandParams,
} from "@/models/api/commands/order/CopyAttributeToOtherOrderItemsCommand";
import {
  OrderItemChangeCommand,
  OrderItemChangeCommandParams,
} from "@/models/api/commands/order/OrderItemChangeCommand";
import {
  ContractorChangeCommand,
  ContractorChangeCommandParams,
} from "@/models/api/commands/order/ContractorChangeCommand";
import { SetOrderProjectIdCommand } from "@/models/api/commands/order/SetOrderProjectIdCommand";
import { CopyAttributesFromBookingItemCommand } from "@/models/api/commands/order/CopyAttributesFromBookingItemCommand";
import { ConfirmModel } from "@/models/components/popup/Confirm";
import i18n from "@/plugins/i18n";
import { filterCapitalize } from "@/filters/capitalize";
import { RecalculateTradeTermCommand } from "@/models/api/commands/order/RecalculateTradeTermCommand";
import { UpdateTradeTermCommand } from "@/models/api/commands/order/UpdateTradeTermCommand";
import { ImportAdvanceDocumentsCommand } from "@/models/api/commands/order/ImportAdvanceDocumentsCommand";
import { ReturnAdvanceInvoiceCommand } from "@/models/api/commands/order/ReturnAdvanceInvoiceCommand";
import { OrderGetTemporaryOwner } from "@/models/api/orders/temporary/OrderGetTemporaryOwners";
import {
  AttributeFromContractor,
  ChangeAttributesFromPayerCommand,
} from "@/models/api/commands/order/ChangeAttributesFromPayerCommand";
import { SaveOrderCommand } from "@/models/api/commands/order/SaveOrderCommand";
import { AddServicePackageCommand } from "@/models/api/commands/order/AddServicePackageCommand";
import {
  UpdateCorrectionReasonParams,
  UpdateCorrectionReasonCommand,
} from "@/models/api/commands/order/UpdateCorrectionReasonCommand";
import { RefreshContractorCommand } from "@/models/api/commands/order/RefreshContractorCommand";

// export interface OrderAddEditCommandsStateInterface {
//   //TODO
// }

// export const OrderAddEditCommandsState: OrderAddEditCommandsStateInterface*/ = {
//   //TODO
// };

const OrderAddEditCommandsModule = defineModule({
  state: {}, //OrderAddEditCommandsState as OrderAddEditCommandsStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {},
  actions: {
    async updateSaleDate(context, newDate: string) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setSaleDate(newDate);
        const command = new SaleDateChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          newDate
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async updateIssueDate(context, newDate: string) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setIssueDate(newDate);
        const command = new IssueDateChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          newDate
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async updateComment(context, comment: string) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setComment(comment);
        const command = new CommentChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          comment
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async updateCorrectionReason(context, correctionReason: UpdateCorrectionReasonParams) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setCorrectionReason(correctionReason);
        const command = new UpdateCorrectionReasonCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          correctionReason
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async updateBankAccount(context, bankAccountId: number) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setBankAccountId(bankAccountId);
        const command = new BankAccountChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          bankAccountId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async updateSummaryPrint(context, param: boolean) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setBuyerSummaryPrint(param);
        const command = new UpdateSummaryPrintCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async setChargeFromPayer(context, param: boolean) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setChargeFromPayer(param);
        const command = new SetChargeFromCustomContractorCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          {
            ContractorType: CONTRACTOR_TYPES.Payer,
            IsSelected: param,
          } as ChargeFromContractor
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async setChargeFromReceiver(context, param: boolean) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setChargeFromReceiver(param);
        const command = new SetChargeFromCustomContractorCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          {
            ContractorType: CONTRACTOR_TYPES.Receiver,
            IsSelected: param,
          } as ChargeFromContractor
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async setAttributesFromPayer(context, param: boolean) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setAttributesFromPayer(param);
        const command = new ChangeAttributesFromPayerCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          {
            ContractorType: CONTRACTOR_TYPES.Payer,
            IsSelected: param,
          } as AttributeFromContractor
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async setAttributesFromReceiver(context, param: boolean) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setAttributesFromReceiver(param);
        const command = new ChangeAttributesFromPayerCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          {
            ContractorType: CONTRACTOR_TYPES.Receiver,
            IsSelected: param,
          } as AttributeFromContractor
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async setContractorIsHidden(context, param: boolean) {
      const { rootDispatch, rootState, rootCommit } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        rootCommit.orderAddEdit.setContractorIsHidden(param);
        const command = new ContractorSetHiddenCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async deleteOrderItem(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new DeleteOrderItemCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async clearContractor(context, contractorType: CONTRACTOR_TYPES) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ClearContractorCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          contractorType
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async refreshContractor(context, contractorType: CONTRACTOR_TYPES) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new RefreshContractorCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          contractorType
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async setContractorContractor(context, param: ContractorChangeCommandParams) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ContractorChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param
        );
        command.CommandName = "ContractorChange";
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async setContractorDataContractor(context, param: ContractorChangeCommandParams) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ContractorChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param
        );
        command.CommandName = "ContractorDataChange";

        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async formOfPaymentChange(context, formOfPaymentId: number) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new FormOfPaymentChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          {
            // eslint-disable-next-line
            BankAccountId: rootState.orderAddEdit.orderSection!.bankAccountId, //todo,
            FormOfPaymentId: formOfPaymentId,
          }
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async paymentDateChange(context, param: PaymentDateChangeCommandParams) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new PaymentDateChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async currencyChange(context, currency: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        if (rootState.orderAddEdit.orderSection) rootState.orderAddEdit.orderSection.currencyCode = currency;
        const command = new CurrencyChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          currency
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async resetOrderItem(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ResetOrderItemCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId,
          false
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async resetRelatedOrderItem(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ResetRelatedOrderItemCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId,
          false
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async returnBookingToList(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ReturnBookingItemCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId,
          false
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async returnRelatedBookingToList(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ReturnRelatedBookingItemCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId,
          false
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async refundBookingItem(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new RefundBookingItemCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async returnAdvanceInvoice(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ReturnAdvanceInvoiceCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async duplicateOrderItem(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new DuplicateOrderItemCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async recalculateAllOrderItems(context, dateType: number) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new RecalculateAllOrderItemsCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          dateType
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async orderItemMoveTo(context, param: OrderItemMoveToPositionCommandParams) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new OrderItemMoveToPositionCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async importMarkedBookingItems(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ImportBookingItemsCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          {
            MarkedByUser: true,
            CalculateBookingItems: rootState.orderAddEdit.bookingItemsToImport,
            Guids: [],
          }
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async removeFees(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new RemoveFeesCommand(rootState.orderAddEdit.sessionId, rootState.orderAddEdit.operationId);
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async saveTradeTermToOtherOrder(context) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new SaveTradeTermToOtherOrderCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async addOwner(context, param: AddOwnerParams) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new AddOwnerCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    modifyOwnerTypeShareToBeValid(context, param: OrderGetTemporaryOwner): EditOwnerParams {
      const { rootState } = _moduleActionContext(context);
      let maxAllowedShare = 100;
      const otherOwners = rootState.orderAddEdit.owners.filter(
        (v) => v.ownerType === param.ownerType && v.id !== param.id
      );
      for (const otherOwner of otherOwners) {
        maxAllowedShare -= otherOwner.share;
      }
      if (param.share > maxAllowedShare) param.share = maxAllowedShare;
      if (param.share < 1) param.share = 1;
      return param;
    },
    async editOwner(context, param: OrderGetTemporaryOwner) {
      const { dispatch, rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        param = await dispatch.modifyOwnerTypeShareToBeValid(param);
        const command = new EditOwnerCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async removeOwner(context, ownerId: number) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new DeleteOwnerCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          ownerId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async orderItemMoveUp(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new OrderItemMoveUpCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async orderItemMoveDown(context, orderItemId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new OrderItemMoveDownCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async ownerChange(context, param: { orderItemId: string; ownerId: number }) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new OwnerChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param.ownerId,
          param.orderItemId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async complementAmountToAll(context, param: ComplementAmountToAllCommand) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        param.OperationId = rootState.orderAddEdit.operationId;
        param.SessionId = rootState.orderAddEdit.sessionId;
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(param);
      }
    },
    async complementAmount(context, param: ComplementAmountCommand) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        param.SessionId = rootState.orderAddEdit.sessionId;
        param.OperationId = rootState.orderAddEdit.operationId;
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(param);
      }
    },
    async addServicePackage(context, servicePackageId: string) {
      const { rootDispatch, rootState } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new AddServicePackageCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          servicePackageId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async addTradeTermToAll(context, param: AddTradeTermToAllCommand) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        param.SessionId = rootState.orderAddEdit.sessionId;
        param.OperationId = rootState.orderAddEdit.operationId;
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(param);
      }
    },
    async addTradeTerm(context, param: AddTradeTermCommand) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        param.SessionId = rootState.orderAddEdit.sessionId;
        param.OperationId = rootState.orderAddEdit.operationId;
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(param);
      }
    },
    async updateTradeTerm(context, param: UpdateTradeTermCommand) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        param.SessionId = rootState.orderAddEdit.sessionId;
        param.OperationId = rootState.orderAddEdit.operationId;
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(param);
      }
    },
    async copyAttributeToOtherOrderItems(
      context,
      param: {
        attribute: OrderGetServiceTypeAttributeItem;
        orderItemId: string;
      }
    ) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new CopyAttributeToOtherOrderItemsCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          {
            AttributePrototypeId: param.attribute.attributePrototypeId as unknown as number,
            Value: param.attribute.value as string,
            OrderItemId: param.orderItemId,
            IsPrintable: param.attribute.isPrintable,
          } as CopyAttributeToOtherOrderItemsCommandParams
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async orderItemChange(context, param: OrderItemChangeCommandParams) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new OrderItemChangeCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          param
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async projectChange(context, projectId: string) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new SetOrderProjectIdCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          projectId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async importAttributesFromBooking(context, bookingId: number) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new CopyAttributesFromBookingItemCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          bookingId,
          rootState.orderAddEdit.orderItemIdToImportAttributes as string
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async importAdvanceDocuments(
      context,
      param: {
        documentIds: Array<string>;
        recalculateAdvanceDocuments: boolean;
      }
    ) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new ImportAdvanceDocumentsCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          {
            DocumentIds: param.documentIds,
            RecalculateAdvanceDocument: param.recalculateAdvanceDocuments,
          }
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async updateTradeTerms(context, orderItemId: string) {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      const recalculatePercentage = await rootDispatch.popup.addConfirm(
        new ConfirmModel(
          filterCapitalize(i18n.t("doYouWantToRecalculatePercentage?")),
          filterCapitalize(i18n.t("warning")),
          [
            {
              text: filterCapitalize(i18n.t("no")),
              color: "warning",
              value: false,
              outlined: true,
            },
            {
              text: filterCapitalize(i18n.t("yes")),
              color: "warning",
              value: true,
            },
          ]
        )
      );
      if (
        recalculatePercentage &&
        rootState.orderAddEdit.sessionId !== null &&
        rootState.orderAddEdit.operationId !== null
      ) {
        const command = new RecalculateTradeTermCommand(
          rootState.orderAddEdit.sessionId,
          rootState.orderAddEdit.operationId,
          orderItemId
        );
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
    async saveOrder(context): Promise<void> {
      const { rootState, rootDispatch } = _moduleActionContext(context);
      if (rootState.orderAddEdit.sessionId !== null && rootState.orderAddEdit.operationId !== null) {
        const command = new SaveOrderCommand(rootState.orderAddEdit.sessionId, rootState.orderAddEdit.operationId);
        await rootDispatch.orderAddEdit.queryUpdateOrderTemporary(command);
      }
    },
  },
});

export default OrderAddEditCommandsModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, OrderAddEditCommandsModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, OrderAddEditCommandsModule);
